export default "https://assets.egbcdn.net/assets/packs/_/images/referrals/devices-3974a31b7cb06d7dadca2f9269c4a524.png";